import { Button } from 'primereact/button';
import { useCellEditing } from '../../../../../shared/hooks/CellEditing';
import { generateId } from '../../../../../utils/generateId';
import { useState } from 'react';

export const ServiceProvider = ({ items, setItems, options }) => {
  const [filteredOptions, setFilteredOptions] = useState(options);
  const { render: renderEditing, selectedItem: editingItem, setSelectedItem: setEditingItem } = useCellEditing({
    dataKey: 'id',
    columns: [
      {
        field: 'index', header: 'STT', style: { textAlign: 'center' }, dataType: 'custom', customCell(rowData: any, rowIndex): any {
          return rowIndex + 1;
        }
      },
      {
        field: 'partnerName', header: 'Tên tổ chức cung cấp dịch vụ', dataType: "autocomplete", required: true, editable: true, style: { minWidth: '160px', maxWidth: '160px' },
        inputProps: {
          field: 'partnerName',
          suggestions: filteredOptions,
          completeMethod: (event) => {
            const query = event.query.toLowerCase();
            const filtered = options.filter((item) => item.partnerName.toLowerCase().includes(query));
            setFilteredOptions(filtered);
          },
          itemTemplate: (item) => {
            return item.partnerName;
          }
        }
      },
      { field: 'partnerTaxCode', header: 'Mã số thuế', required: true, editable: true, style: { minWidth: '170px' } },
      { field: 'fromDate', header: 'Ngày bắt đầu sử dụng dịch vụ', editable: true, dataType: 'date', style: { minWidth: '100px', maxWidth: '100px' } },
      { field: 'toDate', header: 'Ngày kết thúc sử dụng dịch vụ', editable: true, dataType: 'date', style: { minWidth: '100px', maxWidth: '100px' } },
      {
        field: 'note', header: 'Ghi chú', editable: true, style: { minWidth: '170px' }
      }
    ],
    items: items,
    onCellChange: (rowData, column, newValue) => {
      const _items = [...items];
      for (const _item of _items) {
        if (_item.id === rowData.id) {
          if (column.field === 'partnerName') {
            const selectedOption = options.find(option => option.partnerName === newValue.partnerName);
            if (selectedOption) {
              _item['partnerName'] = selectedOption.partnerName || '';
              _item['partnerTaxCode'] = selectedOption.partnerTaxCode || '';
              _item['fromDate'] = selectedOption.fromDate ? new Date(selectedOption.fromDate) : null;
              _item['toDate'] = selectedOption.toDate ? new Date(selectedOption.toDate) : null;
              _item['note'] = selectedOption.note || '';
              break;
            }
          }
          _item[column.field] = newValue;
        }
      }
      setItems(_items);
    }
  });

  const deleteToken = () => {
    if (editingItem) {
      const _items = items.filter((f) => f.id !== editingItem.id);
      setItems(_items);
      setEditingItem(null);
    }
  }

  return (
    <div className="grid">
      <div className="mb-1 col-12 un-fluid">
        <Button label="Thêm" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={(event) => setItems([...items, { id: generateId() }])} />
        <Button label="Xoá" className="p-button-outlined p-button-danger p-button-sm" onClick={deleteToken} disabled={!editingItem} />
      </div>
      <div className="col-12">
        {renderEditing()}
      </div>
    </div>
  );
}